













import { Component, Vue, Watch, Prop,Mixins } from 'vue-property-decorator'
import fromGroup from './form-group.vue'
// import * as utils from './filters/utils'
import TextMixins from './mixins'
  @Component({
    components: {
      fromGroup
    }
  })
export default class MyComponent extends Mixins(TextMixins) {
  // @Prop({ default: () => { return {} } }) iptData! :any
  multipleChoice : any = []
  SexOptions:any = this.iptData.ext.options
  get pass() {
    // let widget = this.iptData
    let flag = true
    if (!this.requireValid) {
      flag = false
    }
    return flag
  }
  inputHandler() {
    // let ipt:any = this.TextInput
    this.updateVal(this.multipleChoice.join(','))
  }
  mounted() {
  }
}
